import { Group, Highlight, Stack, Text } from '@mantine/core';
import type { AddressAutocompleteItemProps } from './types';

export default function AddressAutocompleteItem({
  primary,
  secondary,
  hls = '',
  icon,
  rightSection,
  primaryProp = {},
  secondaryProp = {},
  isEntrance,
  ...props
}: AddressAutocompleteItemProps) {
  return (
    <Group
      gap="md"
      p={0}
      wrap="nowrap"
      w="100%"
      mih={40}
      style={{ cursor: 'pointer', ...props.style }}
      {...props}
    >
      <Stack justify="center">{icon}</Stack>
      <Stack gap={4}>
        <Text
          component="div"
          title={primary}
          c="neutral.9"
          size="sm"
          fw={600}
          lineClamp={1}
          {...primaryProp}
        >
          <Highlight highlight={hls} inherit>
            {isEntrance ? secondary : primary}
          </Highlight>
        </Text>
        {!isEntrance ? (
          <Text
            component="div"
            title={secondary}
            c="neutral.7"
            size="xs"
            lineClamp={1}
            {...secondaryProp}
          >
            <Highlight highlight={hls} inherit>
              {secondary}
            </Highlight>
          </Text>
        ) : null}
      </Stack>
      <Stack ml="auto" justify="center">
        {rightSection}
      </Stack>
    </Group>
  );
}
